<div class="card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5 class="m-0">{{ 'All Campaigns' | translate }}</h5>
      <div class="card-header-right-icon">
        <div class="dropdown icon-dropdown">
          <button class="btn dropdown-toggle" type="button" (click)="toggle()"><i class="icon-more-alt"></i></button>
          <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday' | translate }}</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body pt-0 campaign-table">
    <div class="recent-table table-responsive currency-table">
      <table class="table">
        <thead>
          <tr>
            <th class="f-light">{{ 'AD Platform' | translate }}</th>
            <th class="f-light">{{ 'Campaign' | translate }}</th>
            <th class="f-light">{{ 'GEO' | translate }}</th>
            <th class="f-light">{{ 'Profitability' | translate }}</th>
            <th class="f-light">{{ 'Max Participation Avai.' | translate }}</th>
            <th class="f-light">{{ 'Status' | translate }}</th>
            <th class="f-light">{{ 'Create' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of campaigns">
            <td class="border-icon {{ item.colorClass }}">
              <div>
                <div class="social-circle"><i class="fa fa-{{ item.icon }}"></i></div>
              </div>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.country }}</td>
            <td>
              <div class="change-currency">
                <app-feather-icons [icon]="item.growthArrow" class="me-1" [ngClass]=" item.growthArrow == 'trending-up' ? 'font-success' : 'font-danger' "></app-feather-icons>
                {{item.growth}}%
              </div>
            </td>
            <td>${{item.amount}}</td>
            <td>
              <button class="btn" [ngClass]="item.badge == 'Active' ?  'badge-light-primary' : 'badge-light-light disabled' ">{{item.badge}}</button>
            </td>
            <td>
              <button class="plus-btn">{{ '+' | translate }}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
